import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../axiosInstance";
import FormError from "./FormError";

const ChangePasswordPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const direction = i18n.language === "ar" ? "rtl" : "ltr";

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();

    if (!currentPassword || !newPassword || !newPasswordConfirmation) {
      toast.error(t("ChangePassword.emptyFields"));
      return;
    }

    if (newPassword !== newPasswordConfirmation) {
      toast.error(t("ChangePassword.passwordMismatch"));
      return;
    }

    setIsLoading(true);
    try {
      await axiosInstance.put("/api/v1/profile/change-password", {
        currentPassword,
        newPassword,
        newPasswordConfirmation,
      });

      toast.success(t("ChangePassword.successMessage"));
      setTimeout(() => {
        navigate("/profile-edit");
      }, 3000);
    } catch (error) {
      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        t("ChangePassword.errorMessage");
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="rbt-header-sticky rbt-header-transpernt-active active-light-mode">
      <section className="py-5" dir={direction}>
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4 p-md-5">
                  <h2 className="text-center fw-bold text-primary-custom mb-4">
                    {t("ChangePassword.title")}
                  </h2>
                  <p className="text-muted text-center mb-4">
                    {t("ChangePassword.subtitle")}
                  </p>

                  <form onSubmit={handleSubmit} noValidate>
                    <div className="mb-4">
                      <div className="form-floating">
                        <input
                          type="password"
                          className="form-control"
                          id="currentPassword"
                          placeholder={t("ChangePassword.currentPassword")}
                          value={currentPassword}
                          onChange={(e) => setCurrentPassword(e.target.value)}
                        />
                        <label htmlFor="currentPassword">
                          {t("ChangePassword.currentPassword")}
                        </label>
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="form-floating">
                        <input
                          type="password"
                          className="form-control"
                          id="newPassword"
                          placeholder={t("ChangePassword.newPassword")}
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <label htmlFor="newPassword">
                          {t("ChangePassword.newPassword")}
                        </label>
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="form-floating">
                        <input
                          type="password"
                          className="form-control"
                          id="newPasswordConfirmation"
                          placeholder={t("ChangePassword.confirmNewPassword")}
                          value={newPasswordConfirmation}
                          onChange={(e) =>
                            setNewPasswordConfirmation(e.target.value)
                          }
                        />
                        <label htmlFor="newPasswordConfirmation">
                          {t("ChangePassword.confirmNewPassword")}
                        </label>
                      </div>
                    </div>

                    <div className="mb-4">
                      <button
                        type="submit"
                        className="btn btn-primary w-100 py-3"
                        disabled={isLoading}
                      >
                        {isLoading
                          ? t("ChangePassword.loading")
                          : t("ChangePassword.submit")}
                      </button>
                    </div>
                  </form>

                  <ToastContainer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChangePasswordPage;
